/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  VStack,
  HStack,
  Text,
  IconButton,
  Box,
  Heading,
  Spacer
} from '@mybridge/ui';
import React, { useState,useContext,useEffect } from 'react';
import {
  ChevronRight,
  ChevronLeft,
  PageIcon,
  TeamIcon,
  TeamNewIcon,
  InvitationIcon,
  SuggestionListIcon,
  EyeViewFilledIcon,
  NetworkFollowerIcon,
  NetworkBlockedIcon,
} from '@mybridge/icons';
import { MyNetworkRequestsSentListing } from '../../manage-network/requests-sent';
import { MyNetworkContext, useMyNetworkContext } from 'v4/components/network/context';
import { MyNetworkSuggestionsListing } from '../../manage-network/suggestions';
import { MyNetworkCircleListing } from 'v4/snippets/profile/network/my-circle-listing';
import { useRouter } from 'next/router';
import MyNetworkSearchInput from 'v4/components/network/network-search-input';

const MyNetworkMobile = ({limit, ...props }) => {
  const networkContext = useMyNetworkContext({
    refetchBlockedEnabled: true,
    refetchPageViewersEnabled: true,
  });

  const {
    myFirstDegreeConnectionsCount,
    myCircle,
    mySecondDegreeConnectionsCount,
    myFollowersCount,
    refetchMyFollowers,
    pendingInvitationsCount,
    suggestions,
    pendingInvitations,
    profileViewersCount,
    blocked,
    blockedIsFetching,
    followingPages,
    followingPagesCount
  } = networkContext;

  const totalSuggestionsCount = [
    suggestions?.university?.length ?? 0,
    suggestions?.location?.length ?? 0,
    suggestions?.follow?.length ?? 0,
    suggestions?.degree?.length ?? 0,
    suggestions?.role?.length ?? 0,
    suggestions?.industry?.length ?? 0
  ].reduce((acc, count, index) => {

    return acc + count;
  }, 0);
  
  
  useEffect(() => {
    refetchMyFollowers?.();
  }, []);
  const [showManageConnections, setShowManageConnections] = useState(false);
  const { pathname, push } = useRouter();
  const showLimitedCards = pathname === '/profile/network';

  const manageConnectionsList = [
    { label: 'Connections', count: myFirstDegreeConnectionsCount || myCircle?.length, route: '/profile/network/my-circle', icon: <TeamIcon width="22" color="#6F6F6F" /> },
    { label: 'Following & followers', count: myFollowersCount, route: '/profile/network/follow', icon: <NetworkFollowerIcon /> },
    { label: 'Pages', count: followingPagesCount, route: '/profile/network/pages', icon: <PageIcon /> },
    // { label: 'My Teams', count: 0, route: '/profile/network', icon: <TeamNewIcon height="22" width="22" color="#6F6F6F" /> },
    { label: 'Invitations', count: pendingInvitationsCount, route: '/profile/network/invitations', icon: <InvitationIcon color="#6F6F6F" /> },
    { label: 'Suggestions', count: totalSuggestionsCount, route: '/profile/network/suggestions', icon: <SuggestionListIcon color="#6F6F6F" /> },
    { label: 'Profile views', count: profileViewersCount, route: '/profile/network/viewers', icon: <EyeViewFilledIcon color="#6F6F6F" /> },
    { label: 'Blocked networks', count: blocked?.length, route: '/profile/network/blocked', icon: <NetworkBlockedIcon /> },
  ];

  const handleMyCircleClick = () => {
    push('/profile/network/my-circle');
  };

  return (
    <Card boxShadow="none">
      <HStack p={3} justifyContent="space-between" alignItems="center">
        {showManageConnections && (
          <HStack w="100%" alignItems="center" pt={2}>
            <IconButton
              icon={<ChevronLeft height="15px" />}
              onClick={() => setShowManageConnections(false)}
              variant="ghost"
              aria-label="Go Back"
            />
            <Box flex="1" textAlign="center" pr="10%">
              <Heading
                fontSize="20px"
                color="brandPrimary.500"
                fontWeight="400"
              >
                Manage Connections
              </Heading>
            </Box>
          </HStack>
        )}
      </HStack>

      {!showManageConnections ? (
        <>
          <VStack spacing={0} align="stretch">
            <HStack
              p={3}
              justifyContent="space-between"
              onClick={() => setShowManageConnections(true)}
              cursor="pointer"
            >
              <Text color="#3D5A80" fontSize="14px">
                Manage Connections
              </Text>
              <ChevronRight height="14px" width="8px" color="#3D5A80" />
            </HStack>
            <HStack
              p={3}
              justifyContent="space-between"
              onClick={() => push('/profile/network/invitations')}
              cursor="pointer"
            >
              <Text color="#3D5A80" fontSize="14px">
                Invitations
              </Text>
              <ChevronRight height="14px" width="8px" color="#3D5A80" />
            </HStack>
            <MyNetworkRequestsSentListing limit={showLimitedCards ? 2 : undefined} />
            <HStack
              p={3}
              justifyContent="space-between"
              onClick={() => push('/profile/network/suggestions')}
              cursor="pointer"
            >
              <Text color="#3D5A80" fontSize="14px">
                People you may know
              </Text>
              <ChevronRight height="14px" width="8px" color="#3D5A80" />
            </HStack>
            <MyNetworkSuggestionsListing
              limit={2}
              suggestions={{
                role_and_industry: [...(suggestions?.role ?? []), ...(suggestions?.industry ?? [])].slice(0, 2),
              }}
            />

            <HStack
              p={3}
              justifyContent="space-between"
              onClick={() => push('/profile/network/my-circle')}
              cursor="pointer"
            >
              <Text color="#3D5A80" fontSize="14px">
                My Circle
              </Text>
              <ChevronRight height="14px" width="8px" color="#3D5A80" />
            </HStack>
            <MyNetworkCircleListing limit={showLimitedCards ? 2 : undefined} />
          </VStack>
        </>
      ) : (

        <VStack spacing={4} align="stretch" p={3}>
          {manageConnectionsList.map((item, index) => (
            <HStack
              key={index}
              p={3}
              justifyContent="space-between"
              onClick={() => push(item.route)}
              cursor="pointer"
            >
              <HStack spacing={2}>
                {item.icon}
                <Text fontSize="15px" color="#6F6F6F">{item.label}</Text>
              </HStack>
              <Text fontSize="15px" color="#6F6F6F">{item.count}</Text>
            </HStack>
          ))}
        </VStack>
      )}
    </Card>
  );
};

export default MyNetworkMobile;
